import { Clock, KeyRound } from 'lucide-react'

interface SessionSettingsCardProps {
  sessionDurationHours: number
  otpExpiryMinutes: number
}

export function SessionSettingsCard({
  sessionDurationHours,
  otpExpiryMinutes,
}: SessionSettingsCardProps): React.JSX.Element {
  return (
    <div className="rounded-xl border border-surface-3 bg-surface-0 p-6">
      <div className="mb-4 flex items-center gap-2">
        <Clock className="h-5 w-5 text-admin-500" />
        <h2 className="text-sm font-medium text-text-primary">Session Settings</h2>
      </div>
      <div className="space-y-3">
        <div className="flex items-center gap-3">
          <KeyRound className="h-4 w-4 text-text-tertiary" />
          <div>
            <p className="text-sm text-text-primary">
              Session Duration: <span className="font-medium">{sessionDurationHours}h</span>
            </p>
            <p className="text-xs text-text-tertiary">Configured server-side</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <KeyRound className="h-4 w-4 text-text-tertiary" />
          <div>
            <p className="text-sm text-text-primary">
              OTP Expiry: <span className="font-medium">{otpExpiryMinutes} min</span>
            </p>
            <p className="text-xs text-text-tertiary">Configured server-side</p>
          </div>
        </div>
      </div>
    </div>
  )
}
